import NavBar from "../navbar";

import './Skills.css';

const SkillComponant = () => {
    
    return (
        <div>
            <NavBar />
            
            <div id='skills-head-container'>
            
                <div id='skills-main-container'>
                    <div className='skills-heading'>
                        <span>04 / TOOLKIT</span>
                        <h2>Skills</h2>
                        <p>Languages, frameworks, databases, and infrastructure tools I have worked with.</p>
                    </div>
            
                    <div id='skills-devicon-container'>
                        
                        <div>
                            <h2 className='skills-techincal-h2'>Languages</h2>
                            
                            <div className='skills-inner-flex'>
                                <div className='skills-img-bg'>
                                    <img title='JavaScript' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg' alt='JavaScript'/>
                                    <span>JavaScript</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='Python' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg' alt='Python'/>
                                    <span>Python</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='HTML5' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg' alt='HTML5'/>
                                    <span>HTML5</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='PHP' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg' alt='PHP'/>
                                    <span>PHP</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='CSS3' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original.svg' alt='CSS3'/>
                                    <span>CSS3</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='LUA' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/lua/lua-original.svg' alt='LUA'/>
                                    <span>Lua</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='C++' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg' alt='C++'/>
                                    <span>C++</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='SASS' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sass/sass-original.svg' alt='Sass'/>
                                    <span>SASS</span>
                                </div>
                                
                            </div>
                        </div>
                        
                        <div>
                            <h2 className='skills-techincal-h2'>Frameworks & Libraries</h2>
                            
                            <div className='skills-inner-flex'>
                                <div className='skills-img-bg'>
                                    <img title='React' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' alt='React'/>
                                    <span>React</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='Redux' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redux/redux-original.svg' alt='Redux'/>
                                    <span>Redux</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='Express' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg' alt='Express'/>
                                    <span>Express</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='Flask' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg' alt='Flask'/>
                                    <span>Flask</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='Sequelize' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sequelize/sequelize-original.svg' alt='Sequelize'/>
                                    <span>Sequelize</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='SQLAlchemy' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlalchemy/sqlalchemy-original.svg' alt='SQLAlchemy'/>
                                    <span>SQLAlchemy</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='Gulp' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/gulp/gulp-plain.svg' alt='Gulp'/>
                                    <span>Gulp</span>
                                </div>
                            </div>
                        </div>
                        
                        
                        <div>
                            <h2 className='skills-techincal-h2'>Databases</h2>
                            
                            <div className='skills-inner-flex'>
                                <div className='skills-img-bg'>
                                    <img title='MySQL' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg' alt='MySQL'/>
                                    <span>MySQL</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='PosegreSQL' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg' alt='PosetreSQL'/>
                                    <span>PostgreSQL</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='SQLite' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sqlite/sqlite-original.svg' alt='SQLite'/>
                                    <span>Sqlite</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='MongoDB' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg' alt='MongoDB'/>
                                    <span>MongoDB</span>
                                </div>
                            </div>
                        </div>
                        
                        <div>
                            <h2 className='skills-techincal-h2'>Other</h2>
                            
                            <div className='skills-inner-flex'>
                                <div className='skills-img-bg'>
                                    <img title='NPM' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/npm/npm-original-wordmark.svg' alt='NPM'/>
                                    <span>NPM</span>
                                </div>

                                <div className='skills-img-bg'>
                                    <img title='Docker' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg' alt='Docker'/>
                                    <span>Docker</span>
                                </div>
                                
                                <div className='skills-img-bg'>
                                    <img title='Kubernetes' className='skills-devicon' src='https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg' alt='Kubernetes'/>
                                    <span>Kubernetes</span>
                                </div>
                                
                            </div>
                        </div>
                
                    </div>
                    
                    
                </div>
            </div>
            
        </div>
    );
};

export default SkillComponant;
